document.addEventListener('DOMContentLoaded', () => {
  let cartReady = false

  if (!customElements.get('gift-box-checkbox')) {
    customElements.define('gift-box-checkbox', class GiftBoxCheckbox extends HTMLElement {
      constructor() {
        super()
        this.productId = Number(this.getAttribute('data-gift-product-id'))
        this.variantId = Number(this.getAttribute('data-gift-id'))

        const cartJson = JSON.parse(this.querySelector('#cart-json').innerHTML)
        this.computeProductInCart(cartJson)

        this.querySelector('#gift-box-checkbox').addEventListener('click', () => {
          if (!this.giftBoxInCart)
            document.querySelector('.gift-wrap-panel').classList.add('active')
          else {
            CartJS.updateItemById(this.variantId, 0)
            CartJS.setAttribute('gift-note', '')
          }
        })

        this.querySelector('#edit-gift-box').addEventListener('click', () => {
          document.querySelector('.gift-wrap-panel').classList.add('active')
        })
      }

      productId = 0
      variantId = 0
      giftBoxInCart = false

      computeProductInCart(cart) {
        if (cart.items.find(item => item.product_id === this.productId)) {
          this.classList.add('activegift')
          this.giftBoxInCart = true
        }

        if (cart.items.length) {
          this.style.display = 'block'
        } else {
          this.style.display = 'none'
        }
      }
    })
  }

  if (!customElements.get('gift-box-panel')) {
    customElements.define('gift-box-panel', class GiftBoxPanel extends HTMLElement {
      constructor() {
        super()
        this.productId = Number(this.getAttribute('data-gift-product-id'))
        this.variantId = Number(this.getAttribute('data-gift-id'))

        setTimeout(() => {
          this.style.display = "flex"
          console.log('show panel')
        }, 500);

        const cartJson = JSON.parse(this.querySelector('#cart-json').innerHTML)
        this.computeProductInCart(cartJson)

        this.querySelectorAll(['#close-gift-box-panel', '#cancel-gift-box']).forEach(item => item.addEventListener('click', () => {
          this.classList.remove('active')
        }))

        this.querySelector('#add-gift-box-product').addEventListener('click', (event) => {
          if (!this.giftBoxInCart)
            CartJS.addItem(this.variantId)
          CartJS.setAttribute('gift-note', this.querySelector('#gift-note').value)
          event.target.classList.add('free-gift-loading')
        })

        $(document).on('cart.requestComplete', () => {
          this.classList.remove('active')
          this.querySelector('#add-gift-box-product').classList.remove('free-gift-loading')
        })

        this.querySelector('#gift-note').addEventListener('keydown', (event) => {
          const textLength = event.target.value.length

          this.querySelector('.left-text strong').innerHTML = 200 - textLength
        })
      }

      productId = 0
      variantId = 0
      giftBoxInCart = false

      computeProductInCart(cart) {
        if (cart.items.find(item => item.product_id === this.productId)) {
          this.giftBoxInCart = true
        }

        if (this.giftBoxInCart) {
          document.querySelector('#gift-note').value = cart.attributes["gift-note"]
          document.querySelector('#add-gift-box-product span').innerHTML = "UPDATE"
        } else {
          document.querySelector('#gift-note').value = ''
          document.querySelector('#add-gift-box-product span').innerHTML = "ADD TO ORDER"
        }

        const rate = Number(window.Shopify.currency.rate)
        const giftBoxAmount = Number(this.getAttribute('data-free-amount')) * rate

        console.log('gift box amount', giftBoxAmount, rate)

        if (cart.total_price >= giftBoxAmount) {
          this.querySelectorAll('.price-text').forEach(item => {
            console.log(item)
            if (item.classList.contains('free')) {
              item.style.display = "block"
            }
          })
        } else {
          this.querySelectorAll('.price-text').forEach(item => {
            if (item.classList.contains('original')) {
              item.style.display = "block"
            }
          })
        }
      }
    })
  }
})